import styled from 'styled-components';
import white from 'sushiweb/tokens/color/white';
import grey from 'sushiweb/tokens/color/grey';
import red from 'sushiweb/tokens/color/red';
import Header from 'sushiweb/Layouts/Header';
import Bell from 'sushiweb/Icons/all/Bell';
import coal from 'sushiweb/tokens/color/black';

export const HeaderWrapper = styled.div`
  margin-left: 27rem;
  padding: 10px;
  background: ${props =>
    props.isStagging ? red.z100 : 'var(--coolgreycoolgrey-50, #f8f9fc)'};
  border-bottom: 0.1rem solid ${grey.z200};
  position: fixed;
  top: 0;
  z-index: 10;
  width: calc(100vw - 27rem);
  height: 7.2rem;
  @media (max-width: 480px) {
    margin-bottom: 0;
  }
`;
export const HeaderCenterWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 0rem 2rem;
`;
export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 1310px;
`;

export const HeaderDetailsContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const CompanyWrapper = styled.div``;

export const BalanceWrapper = styled.div`
  padding: 15px;
`;
Header.Element = styled.nav`
  width: 100%;
  max-width: 95%;
  margin: 0 auto;
  display: flex;
  flex-wrap: nowrap;
  height: 100%;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 4;
`;

export const NotificationBell = styled(Bell)`
  cursor: pointer;
`;

export const BellWrapper = styled.div`
  position: relative;
`;

export const NotifCount = styled.div`
  position: absolute;
  color: ${white};
  background-color: ${red.z500};
  top: 2.5px;
  right: 5px;
  font-size: 1.2rem;
  padding: 2px;
  border-radius: 4px;
  min-width: 20px;
  text-align: center;
  transform: translate(50%, -50%);
`;

export const Anchor = styled.div`
  color: ${coal};
  display: flex;
  justify-content: space-between;
`;

export const BalanceWidgetLink = styled.div`
  font-size: 1.6rem;
  width: 100%;
  padding: 1.5rem 2rem;
  background: ${white};
  text-align: left;
  :hover {
    background: ${grey.z200};
  }
`;
export const BalanceWidgetWrapper = styled.div`
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};
  position: relative;
  top: 0rem;
  margin-top: -1rem;
`;

export const BalanceDetailsWrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.5rem;
  background: ${white};
  border: 1px solid ${grey.z200};
  border-radius: 12px;
  padding: 0.8rem 1.6rem;
  gap: 0.4rem;
  #amount {
    font-family: Lexend-400;
    font-weight: 600;
    color: ${coal};
  }
`;

export const IncreaseLimitLink = styled.span`
  margin-left: 0.8rem;
  color: ${red.z500};
  font-size: 1.3rem;
  font-family: Lexend-500;
  cursor: pointer;
  white-space: nowrap;
  background: ${red.z100};
  border-radius: 8px;
  padding: 0.4rem 1rem;
`;

export const BalanceWidgetDropdown = styled.div`
  position: absolute;
  top: 2rem;
  right: 0;
  visibility: ${props => (props.visible ? 'visible' : 'hidden')};
  opacity: ${props => (props.visible ? 1 : 0)};
  width: 16rem;
  background: ${white};
  border-radius: 8px;
  box-shadow: 0px 2px 8px rgba(28, 28, 28, 0.15);
  transform: translateY(${props => (props.visible ? '20px' : 0)});
  transition: transform 0.25s ease, opacity 0.25s ease;
  overflow: hidden;
`;

export const BalanceWidgetHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  max-width: 16rem;
`;

export const BalanceWidgetName = styled.span`
  font-weight: 500;
  margin: 0 0 0 0rem;
  color: ${coal};

  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const CompanyDetailsWrapper = styled.div`
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};
  position: relative;
`;

export const CompanyDetailsHead = styled.div`
  display: flex;
  align-items: center;
  max-width: 16rem;
`;

export const CompanyLogoWrapper = styled.div``;

export const CompanyNameWrapper = styled.span`
  font-size: 1.5rem;
  font-weight: 500;
  color: ${coal};
  padding-left: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
